'use client';

import { useState } from 'react';

import type { Raffle } from '@/types/models/Raffle';

type UseRafflesListProps = {
  raffles: Raffle[];
};

type UseRafflesListReturn = {
  raffles: Raffle[];
  totalRaffles: number;
  filteredRaffles: Raffle[];
  setFilteredRaffles: (raffles: Raffle[]) => void;
};

export const useRafflesList = ({
  raffles,
}: UseRafflesListProps): UseRafflesListReturn => {
  const [filteredRaffles, setFilteredRaffles] = useState<Raffle[]>(raffles);
  const totalRaffles = raffles.length;

  return {
    raffles,
    filteredRaffles,
    totalRaffles,
    setFilteredRaffles,
  };
};
